import { useDispatch, useSelector } from "react-redux";
import {
  getLinkedInProfiles,
  getLinkedInProfileByIdAction,
  createLinkedInProfileAction,
  updateLinkedInProfileAction,
  deleteLinkedInProfileAction,
  searchLinkedInProfilesAction,
  getLinkedInProfilesByJDAction,
  getLinkedInProfilesByClientAction,
  getLinkedInProfilesByJDAndClientAction,
  getLinkedInProfilesStatisticsAction,
  filterLinkedInProfilesAction
} from "../actions/linkedinProfilesActions";
import {
  setError as SetError,
  selectFilteredProfiles,
  selectStatistics,
  // Filter actions
  setSearchTerm,
  setSelectedJDs,
  setSelectedClients,
  setActiveOnly,
  setDateRange,
  clearAllFilters,
  // Filter selectors
  selectFilters,
  selectSearchTerm,
  selectSelectedJDs,
  selectSelectedClients,
  selectActiveOnly,
  selectDateRange
} from "../slices/linkedinProfilesSlice";

const useLinkedInProfiles = () => {
  const dispatch = useDispatch();
  const linkedin_profiles_list = useSelector((state) => state.linkedinProfiles.linkedin_profiles_list);
  const profiles = useSelector((state) => state.linkedinProfiles.linkedin_profiles_list.profiles || state.linkedinProfiles.linkedin_profiles_list);
  const filteredProfiles = useSelector(selectFilteredProfiles);
  const statistics = useSelector(selectStatistics);
  const loading = useSelector((state) => state.linkedinProfiles.loading);
  const error = useSelector((state) => state.linkedinProfiles.error);
  
  // Filter selectors
  const filters = useSelector(selectFilters);
  const searchTerm = useSelector(selectSearchTerm);
  const selectedJDs = useSelector(selectSelectedJDs);
  const selectedClients = useSelector(selectSelectedClients);
  const activeOnly = useSelector(selectActiveOnly);
  const dateRange = useSelector(selectDateRange);
  
  const setError = (error) => {
    return dispatch(SetError(error));
  };

  const loadLinkedInProfilesList = async (params = {}) => {
    return dispatch(getLinkedInProfiles(params));
  };

  const loadLinkedInProfileById = async (profileId) => {
    return dispatch(getLinkedInProfileByIdAction(profileId));
  };

  const createNewLinkedInProfile = async (profileData) => {
    return dispatch(createLinkedInProfileAction(profileData));
  };

  const updateExistingLinkedInProfile = async (profileId, updateData) => {
    return dispatch(updateLinkedInProfileAction(profileId, updateData));
  };

  const deleteExistingLinkedInProfile = async (profileId) => {
    return dispatch(deleteLinkedInProfileAction(profileId));
  };

  const searchLinkedInProfiles = async (searchTerm, limit = 50) => {
    return dispatch(searchLinkedInProfilesAction(searchTerm, limit));
  };

  const loadLinkedInProfilesByJD = async (jdId, params = {}) => {
    return dispatch(getLinkedInProfilesByJDAction(jdId, params));
  };

  const loadLinkedInProfilesByClient = async (clientId, params = {}) => {
    return dispatch(getLinkedInProfilesByClientAction(clientId, params));
  };

  const loadLinkedInProfilesByJDAndClient = async (jdId, clientId, params = {}) => {
    return dispatch(getLinkedInProfilesByJDAndClientAction(jdId, clientId, params));
  };

  const loadLinkedInProfilesStatistics = async () => {
    return dispatch(getLinkedInProfilesStatisticsAction());
  };

  const filterLinkedInProfiles = async (filters) => {
    return dispatch(filterLinkedInProfilesAction(filters, profiles));
  };

  // Filter action functions
  const updateSearchTerm = (term) => dispatch(setSearchTerm(term));
  const updateSelectedJDs = (jds) => dispatch(setSelectedJDs(jds));
  const updateSelectedClients = (clients) => dispatch(setSelectedClients(clients));
  const updateActiveOnly = (active) => dispatch(setActiveOnly(active));
  const updateDateRange = (range) => dispatch(setDateRange(range));
  const clearFilters = () => dispatch(clearAllFilters());

  return {
    loadLinkedInProfilesList,
    loadLinkedInProfileById,
    createNewLinkedInProfile,
    updateExistingLinkedInProfile,
    deleteExistingLinkedInProfile,
    searchLinkedInProfiles,
    loadLinkedInProfilesByJD,
    loadLinkedInProfilesByClient,
    loadLinkedInProfilesByJDAndClient,
    loadLinkedInProfilesStatistics,
    filterLinkedInProfiles,
    linkedin_profiles_list,
    profiles,
    filteredProfiles,
    statistics,
    loading,
    error,
    setError,
    // Filter state
    filters,
    searchTerm,
    selectedJDs,
    selectedClients,
    activeOnly,
    dateRange,
    // Filter actions
    updateSearchTerm,
    updateSelectedJDs,
    updateSelectedClients,
    updateActiveOnly,
    updateDateRange,
    clearFilters
  };
};

export default useLinkedInProfiles;
